<template>
  <div class="card-shipping-fees-page">
    <app-page-header title="Taxas de envio de cartões"></app-page-header>
    <card-shipping-fees-table></card-shipping-fees-table>
  </div>
</template>

<script>
import CardShippingFeesTable from '@/components/Tables/CardShippingFeesTable.vue';

export default {
  name: 'card-shipping-fees-page',
  components: {
    CardShippingFeesTable,
  },
};
</script>

<style lang="sass" scoped></style>
